import FooterContent from "../molecules/FooterContent";

function FooterComponent() {
  return <FooterContent />;
}

export default FooterComponent;
